import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { catchError, map, of } from 'rxjs';

import { createEffectFactory } from '@core/ngrx-legacy';

import { TellentGettingStartedHttpClient } from './tellent-getting-started.http-client';
import { TellentGettingStartedProgressActions } from './tellent-getting-started.store';

@Injectable({
  providedIn: 'root',
})
export class TellentGettingStartedProgressEffects {
  #actions$ = inject(Actions);
  #http = inject(TellentGettingStartedHttpClient);

  public effects = createEffectFactory(TellentGettingStartedProgressActions, this.#actions$);

  public fetch$ = this.effects(TellentGettingStartedProgressActions.fetch, () =>
    this.#http.fetchProgress(),
  );

  public updateStepProgress$ = this.effects(
    TellentGettingStartedProgressActions.updateStepProgress,
    ({ payload }) =>
      this.#http.updateStepProgress(payload).pipe(
        map(payload => TellentGettingStartedProgressActions.updateStepProgressSuccess({ payload })),
        catchError(() => of(TellentGettingStartedProgressActions.updateStepProgressFailed())),
      ),
  );

  public dismissGuide$ = this.effects(TellentGettingStartedProgressActions.dismissGuide, () =>
    this.#http.dismissGuide().pipe(
      map(payload => TellentGettingStartedProgressActions.dismissGuideSuccess({ payload })),
      catchError(() => of(TellentGettingStartedProgressActions.dismissGuideFailed())),
    ),
  );
}
